import DeleteButton from "@components/buttons/DeleteButton";
import OutlinedStatus from "@components/status/OutlinedStatus";
import { TPushNotification } from "@type-defs/others/TPushNotification";

export const pushNotificationColumnNames = [
  "Title",
  "Message",
  "Role",
  "Schedule",
  "Send Status",
  "Status",
  "Action",
];

export const pushNotificationColumns = (
  deleteHandler: (id: number | string) => void,
  sendHandler: (id: number | string) => void,
  canDelete: boolean,
  canCreate: boolean
) => [
  {
    name: "Title",
    selector: (row: TPushNotification) => row.title,
    grow: 1.2,
  },
  {
    name: "Message",
    selector: (row: TPushNotification) => (
      <div className="max-w-[24rem] truncate" title={row.message}>
        {row.message}
      </div>
    ),
    grow: 1.6,
  },
  {
    name: "Role",
    selector: (row: TPushNotification) =>
      row.user_role_name || row.user_role_id,
    grow: 0.8,
  },
  {
    name: "Schedule",
    selector: (row: TPushNotification) => (
      <div className="text-sm">
        <div className="capitalize">{row.schedule_type}</div>
        <div>{row.scheduled_at || "-"}</div>
      </div>
    ),
    grow: 0.9,
  },
  {
    name: "Send Status",
    selector: (row: TPushNotification) => (
      <OutlinedStatus
        width="w-[12ch]"
        color={row.send_status === "sent" ? "green" : "yellow"}
        title={row.send_status || "draft"}
      />
    ),
    grow: 0.7,
  },
  {
    name: "Status",
    selector: (row: TPushNotification) => (
      <OutlinedStatus
        width="w-[10ch]"
        color={String(row.status) === "1" ? "green" : "red"}
        title={String(row.status) === "1" ? "Active" : "InActive"}
      />
    ),
    grow: 0.6,
  },
  {
    name: "Action",
    right: "true",
    selector: (row: TPushNotification) => (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {canCreate ? (
          <button
            type="button"
            className="rounded border border-primary px-2 py-1 text-xs text-primary disabled:cursor-not-allowed disabled:opacity-50"
            onClick={() => sendHandler(row.push_notification_id || "")}
            disabled={row.send_status === "sent" || String(row.status) !== "1"}
          >
            Send Now
          </button>
        ) : null}
        {canDelete ? (
          <DeleteButton
            id={row.push_notification_id || ""}
            actionHandler={() => deleteHandler(row.push_notification_id || "")}
          />
        ) : null}
      </div>
    ),
  },
];
